import { TABLET_API_ORIGIN } from '@/global/env';
import { RestClientInterface } from '@/lib/restClient';
import { AssociateBrand } from '@/services/AssociateBrand/hooks/list/useAssociateBrandList';

interface Interface {
  list: () => Promise<AssociateBrand[]>;
}

export class AssociateBrandService implements Interface {
  constructor(private readonly restClient: RestClientInterface) {}
  public async list(): Promise<AssociateBrand[]> {
    return await this.restClient.get<AssociateBrand[]>(
      `${TABLET_API_ORIGIN}/dashboard-api/associate-brands/list` as const
    );
  }
}
